import { render, staticRenderFns } from "./rightDialog.vue?vue&type=template&id=1d271efc&scoped=true"
import script from "./rightDialog.vue?vue&type=script&lang=js"
export * from "./rightDialog.vue?vue&type=script&lang=js"
import style0 from "./rightDialog.vue?vue&type=style&index=0&id=1d271efc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d271efc",
  null
  
)

export default component.exports